import { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import css from "../catalog/catalog.module.css";
import ProductNewCross from "../standartComponent/productComponent/productNewCross";

export default function ViewProductCros({
  currentProductId,
  setAddressChanged,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (!currentProductId) {
        return;
      }

      const productsSnapshot = await getDocs(collection(db, "product"));
      const allProducts = [];
      productsSnapshot.forEach((doc) => {
        allProducts.push({ id: doc.id, ...doc.data() });
      });

      const bundlesSnapshot = await getDocs(collection(db, "bundles"));
      const bundles = [];
      bundlesSnapshot.forEach((doc) => {
        bundles.push({ id: doc.id, ...doc.data() });
      });

      let found = [];

      bundles.forEach((bundle) => {
        const isCurrentIncluded = bundle.products.some(
          (p) => p.productId === currentProductId
        );
        if (isCurrentIncluded) {
          bundle.products.forEach((p) => {
            if (p.productId !== currentProductId) {
              const matchedProduct = allProducts.find(
                (prod) => prod.id === p.productId
              );
              if (matchedProduct) {
                found.push({
                  ...matchedProduct,
                  discount: p.discount,
                });
              }
            }
          });
        }
      });

      const unique = found.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );

      setRelatedProducts(unique);
    };

    fetchRelatedProducts();
  }, [currentProductId]);

  if (!relatedProducts.length) {
    return null;
  }

  return (
    <div className="youLikeItWrapNew">
      <div className="youLikewrapSmall">
        <h2 className="ProductCatalogH2">Разом дешевше</h2>
        <div className={css.youLikeProductWrap}>
          {relatedProducts.slice(0, 3).map((el) => (
            <ProductNewCross
              key={el.id}
              el={el}
              discount={el.discount}
              setAddressChanged={setAddressChanged}
              setCartCounterC={setCartCounterC}
              setLikeCounterC={setLikeCounterC}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
